import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { ArrowRight, ArrowDown, CheckCircle } from 'lucide-react';
import { heroContent, companyInfo } from '../../data/mock';

export const Hero = () => {
  const scrollToAbout = () => {
    document.getElementById('quem-somos')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-b from-slate-50 to-white">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 -right-40 w-96 h-96 bg-teal-100 rounded-full blur-3xl opacity-50" />
        <div className="absolute -bottom-20 -left-40 w-96 h-96 bg-cyan-100 rounded-full blur-3xl opacity-50" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-br from-teal-50 to-cyan-50 rounded-full blur-3xl opacity-30" />
      </div>

      {/* Grid Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(15,118,110,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(15,118,110,0.03)_1px,transparent_1px)] bg-[size:60px_60px]" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div className="text-left">
            <Badge className="mb-6 bg-teal-100 text-teal-700 border-teal-200 hover:bg-teal-100 px-4 py-1.5">
              {heroContent.badge}
            </Badge>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight mb-6">
              {heroContent.title.split(' ').map((word, i) => (
                <span key={i}>
                  {word === 'Próximo' || word === 'Nível' ? (
                    <span className="text-teal-600">{word} </span>
                  ) : (
                    word + ' '
                  )}
                </span>
              ))}
            </h1>
            
            <p className="text-lg sm:text-xl text-slate-600 mb-8 leading-relaxed max-w-xl">
              {heroContent.subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <Button
                size="lg"
                onClick={scrollToContact}
                className="bg-teal-600 hover:bg-teal-700 text-white shadow-xl shadow-teal-600/20 hover:shadow-teal-600/30 transition-all duration-300 h-14 px-8 text-base"
              >
                {heroContent.primaryCta}
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={scrollToAbout}
                className="border-slate-300 text-slate-700 hover:bg-slate-50 h-14 px-8 text-base"
              >
                <ArrowDown className="w-5 h-5 mr-2" />
                {heroContent.secondaryCta}
              </Button>
            </div>

            <div className="flex flex-wrap gap-6">
              {['Sites Responsivos', 'SEO Otimizado', 'Suporte Dedicado'].map((item) => (
                <div key={item} className="flex items-center gap-2 text-slate-600">
                  <CheckCircle className="w-5 h-5 text-teal-600" />
                  <span className="text-sm font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Visual Element - Logo */}
          <div className="relative hidden lg:flex items-center justify-center">
            <div className="relative">
              {/* Main Logo Display */}
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-teal-400/20 to-cyan-400/20 rounded-full blur-3xl scale-150" />
                <img 
                  src={companyInfo.logo}
                  alt={companyInfo.name}
                  className="relative w-80 h-80 rounded-full object-cover shadow-2xl shadow-slate-300/50 border-4 border-white"
                />
              </div>

              {/* Floating Cards */}
              <div className="absolute -top-4 -right-4 bg-white rounded-xl shadow-xl shadow-slate-200/50 px-4 py-3 border border-slate-100 animate-pulse">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
                    <CheckCircle className="w-5 h-5 text-green-600" />
                  </div>
                  <div>
                    <p className="text-xs text-slate-500">Design Moderno</p>
                    <p className="text-sm font-semibold text-slate-800">Sites Profissionais</p>
                  </div>
                </div>
              </div>

              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl shadow-slate-200/50 px-4 py-3 border border-slate-100">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center">
                    <span className="text-teal-600 font-bold text-sm">100%</span>
                  </div>
                  <div>
                    <p className="text-xs text-slate-500">Compromisso Total</p>
                    <p className="text-sm font-semibold text-slate-800">Com o Seu Sucesso</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
